const isRequired = require('../../../utilities/isRequired');
const { ACCEPTABLE_ERROR, pixelRound } = require('./pixelRound');

module.exports = (leftSide = isRequired(), rightSide = isRequired()) => (
    Math.abs(pixelRound(leftSide - rightSide)) <= ACCEPTABLE_ERROR &&
    !Number.isNaN(Math.abs(leftSide - rightSide))
);
